<template>
  <!--  节点创建过程   -->
  <el-dialog
    :title="$t('masterNodeAction.title')"
    :visible.sync="createMasterNodeVisible"
    @close="closeCreateMasterNode"
    width="400px">
    <div style="min-height: 500px; padding-left: 10px">
      <el-steps class="steps_cls" direction="vertical" :active="createMasterNodeListActive" process-status="finish" finish-status="success" :space="60">
        <el-step v-for="(item, index) in createMasterNodeList" :title="item.Text"
                 :description="processTime(item.Time)"
                 :key="index"></el-step>
      </el-steps>
    </div>
    <span slot="footer" class="dialog-footer">
          <el-button :type="this.createMasterNodeListActive !== 8 ? 'primary' : ''"
                     @click="getProjectNodeDeploy(nodeDeployAction)">
            {{ $t('masterNodeAction.refresh') }}
          </el-button>
          <el-button type="primary" v-if="this.createMasterNodeListActive === 8" @click="done">
            {{ $t('masterNodeAction.done') }}
          </el-button>
        </span>
  </el-dialog>
</template>

<script>
import { debounce, processTime } from '@/common/utils/utils';
import { postRequest } from '@/common/libs/request';

export default {
  name: 'MasterNodeAction',
  props: {},
  data() {
    return {
      createMasterNodeVisible: false,
      titleName: this.$t('masterNodeAction.title'),
      createMasterNodeList: [],
      nodeDeployAction: '',
      createMasterNodeListActive: 0,
      processTime,
    };
  },

  methods: {
    /**
     * 轮询获取创建节点流程信息
     */
    getProjectNodeDeploy(data, title) {
      this.nodeDeployAction = data || this.nodeDeployAction;
      this.titleName = title || this.titleName;
      debounce(() => {
        postRequest('/api/eda/common/project/getProjectNodeDeploy', {
          action: this.nodeDeployAction,
        }).then((res) => {
          this.createMasterNodeVisible = true;
          // 满足条件停止递归
          if (res) {
            this.createMasterNodeList = res?.list || [];
            for (let i = 0; i < res?.list.length; i++) {
              if (res?.list[i].Time === 0) {
                this.createMasterNodeListActive = i;
                return;
              }
              this.createMasterNodeListActive = res?.list.length;
            };
          }
        });
      }, 500);
    },

    /**
     * 清空数据
     */
    closeCreateMasterNode() {
      this.createMasterNodeList = [];
      this.createMasterNodeVisible = false;
    },

    /**
     * 所有步骤已完成
     * 完成刷新节点信息
     */
    done() {
      this.createMasterNodeVisible = false;
      this.$parent.getResourceList();
    },
  },
};
</script>

<style scoped lang="scss">
.steps_cls {
  ::v-deep .el-step__title {
    font-size: 14px;
  }
}
</style>
